var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-parte" },
    [
      _c("NavItem", {
        attrs: {
          item: _vm.headerItem,
          subitems: _vm.headerSubitems,
          collapsed: _vm.collapsed,
          mobile: _vm.mobile,
          active: _vm.active,
          "active-variant": _vm.activeVariant,
          "chevron-name": _vm.chevronName,
          expanded: _vm.ariaExpanded,
          controls: _vm.regionId,
          "aria-label": _vm.parte.label
        },
        on: {
          click: _vm.onToggle,
          "hover-subitems": _vm.onHoverSubitems,
          "leave-subitems": function($event) {
            return _vm.$emit("leave-subitems")
          }
        }
      }),
      _c("v-expand-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isOpen,
                expression: "isOpen"
              }
            ],
            staticClass: "nav-parte__region",
            attrs: { id: _vm.regionId }
          },
          [_vm._t("default")],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }